module.exports = __webpack_public_path__ + "img/img1.155cba04.png";